var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1188 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke:#e6e6e6;}.cls-2{stroke:#b3b3b3;}.cls-3{stroke-width:6px;stroke:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1159,
    y1: 177.5,
    x2: 2284.5,
    y2: 177.5,
    gradientTransform: "translate(2346 340) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc1474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fca600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bc3fb"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61,
    y1: 89,
    x2: 1187,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.5,
    y1: 167.5,
    x2: 1187.5,
    y2: 168.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 61.5,
    y1: 245.5,
    x2: 1187.5,
    y2: 246.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 297.5,
    y1: 16.5,
    x2: 297.5,
    y2: 297.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.5,
    y1: 14.5,
    x2: 542.5,
    y2: 295.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 790.5,
    y1: 16.5,
    x2: 790.5,
    y2: 297.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1035.5,
    y1: 14.5,
    x2: 1035.5,
    y2: 295.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1184,
    y1: 150,
    x2: 1184,
    y2: 226
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1187.5,
    y1: 149.5,
    x2: 1180.5,
    y2: 149.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1187.5,
    y1: 226.5,
    x2: 1180.5,
    y2: 226.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1166,
    y1: 133.48,
    x2: 1166,
    y2: 206.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1169.5,
    y1: 133,
    x2: 1162.5,
    y2: 133
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1169.5,
    y1: 207,
    x2: 1162.5,
    y2: 207
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1148,
    y1: 133.46,
    x2: 1148,
    y2: 203.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1151.5,
    y1: 133,
    x2: 1144.5,
    y2: 133
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1151.5,
    y1: 204,
    x2: 1144.5,
    y2: 204
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1131,
    y1: 85.5,
    x2: 1131,
    y2: 161.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1134.5,
    y1: 85,
    x2: 1127.5,
    y2: 85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1134.5,
    y1: 162,
    x2: 1127.5,
    y2: 162
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1113,
    y1: 93.49,
    x2: 1113,
    y2: 167.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1116.5,
    y1: 93,
    x2: 1109.5,
    y2: 93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1116.5,
    y1: 168,
    x2: 1109.5,
    y2: 168
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1096,
    y1: 86.49,
    x2: 1096,
    y2: 160.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1099.5,
    y1: 86,
    x2: 1092.5,
    y2: 86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1099.5,
    y1: 161,
    x2: 1092.5,
    y2: 161
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1078,
    y1: 89.47,
    x2: 1078,
    y2: 160.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1081.5,
    y1: 89,
    x2: 1074.5,
    y2: 89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1081.5,
    y1: 161,
    x2: 1074.5,
    y2: 161
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1060,
    y1: 85.45,
    x2: 1060,
    y2: 153.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1063.5,
    y1: 85,
    x2: 1056.5,
    y2: 85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1063.5,
    y1: 154,
    x2: 1056.5,
    y2: 154
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1043,
    y1: 83.44,
    x2: 1043,
    y2: 150.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1046.5,
    y1: 83,
    x2: 1039.5,
    y2: 83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1046.5,
    y1: 151,
    x2: 1039.5,
    y2: 151
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1025,
    y1: 62.45,
    x2: 1025,
    y2: 131.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1028.5,
    y1: 62,
    x2: 1021.5,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1028.5,
    y1: 132,
    x2: 1021.5,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1008,
    y1: 63.44,
    x2: 1008,
    y2: 130.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1011.5,
    y1: 63,
    x2: 1004.5,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1011.5,
    y1: 131,
    x2: 1004.5,
    y2: 131
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 990,
    y1: 58.44,
    x2: 990,
    y2: 125.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 993.5,
    y1: 58,
    x2: 986.5,
    y2: 58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 993.5,
    y1: 126,
    x2: 986.5,
    y2: 126
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 973,
    y1: 49.44,
    x2: 973,
    y2: 116.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 976.5,
    y1: 49,
    x2: 969.5,
    y2: 49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 976.5,
    y1: 117,
    x2: 969.5,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 955,
    y1: 76.4,
    x2: 955,
    y2: 136.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 958.5,
    y1: 76,
    x2: 951.5,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 958.5,
    y1: 137,
    x2: 951.5,
    y2: 137
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 937,
    y1: 70.39,
    x2: 937,
    y2: 129.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 940.5,
    y1: 70,
    x2: 933.5,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 940.5,
    y1: 130,
    x2: 933.5,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 920,
    y1: 51.4,
    x2: 920,
    y2: 112.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 923.5,
    y1: 51,
    x2: 916.5,
    y2: 51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 923.5,
    y1: 113,
    x2: 916.5,
    y2: 113
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 902,
    y1: 39.42,
    x2: 902,
    y2: 103.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.5,
    y1: 39,
    x2: 898.5,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 905.5,
    y1: 104,
    x2: 898.5,
    y2: 104
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 885,
    y1: 29.42,
    x2: 885,
    y2: 92.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.5,
    y1: 29,
    x2: 881.5,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 888.5,
    y1: 93,
    x2: 881.5,
    y2: 93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 867,
    y1: 22.42,
    x2: 867,
    y2: 86.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 870.5,
    y1: 22,
    x2: 863.5,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 870.5,
    y1: 87,
    x2: 863.5,
    y2: 87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 849,
    y1: 33.42,
    x2: 849,
    y2: 96.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 852.5,
    y1: 33,
    x2: 845.5,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 852.5,
    y1: 97,
    x2: 845.5,
    y2: 97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 832,
    y1: 51.41,
    x2: 832,
    y2: 113.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 835.5,
    y1: 51,
    x2: 828.5,
    y2: 51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 835.5,
    y1: 114,
    x2: 828.5,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 814,
    y1: 62.42,
    x2: 814,
    y2: 126.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 817.5,
    y1: 62,
    x2: 810.5,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 817.5,
    y1: 127,
    x2: 810.5,
    y2: 127
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 796,
    y1: 65.42,
    x2: 796,
    y2: 129.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 799.5,
    y1: 65,
    x2: 792.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 799.5,
    y1: 130,
    x2: 792.5,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 779,
    y1: 60.44,
    x2: 779,
    y2: 127.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 782.5,
    y1: 60,
    x2: 775.5,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 782.5,
    y1: 128,
    x2: 775.5,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 762,
    y1: 48.47,
    x2: 762,
    y2: 119.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.5,
    y1: 48,
    x2: 758.5,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 765.5,
    y1: 120,
    x2: 758.5,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 744,
    y1: 79.45,
    x2: 744,
    y2: 147.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 747.5,
    y1: 79,
    x2: 740.5,
    y2: 79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 747.5,
    y1: 148,
    x2: 740.5,
    y2: 148
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 726,
    y1: 90.44,
    x2: 726,
    y2: 156.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 729.5,
    y1: 90,
    x2: 722.5,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 729.5,
    y1: 157,
    x2: 722.5,
    y2: 157
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 708,
    y1: 113.42,
    x2: 708,
    y2: 177.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 711.5,
    y1: 113,
    x2: 704.5,
    y2: 113
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 711.5,
    y1: 178,
    x2: 704.5,
    y2: 178
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 691,
    y1: 126.41,
    x2: 691,
    y2: 188.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 694.5,
    y1: 126,
    x2: 687.5,
    y2: 126
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 694.5,
    y1: 189,
    x2: 687.5,
    y2: 189
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 673,
    y1: 130.4,
    x2: 673,
    y2: 191.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 676.5,
    y1: 130,
    x2: 669.5,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 676.5,
    y1: 192,
    x2: 669.5,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 656,
    y1: 115.44,
    x2: 656,
    y2: 182.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 659.5,
    y1: 115,
    x2: 652.5,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 659.5,
    y1: 183,
    x2: 652.5,
    y2: 183
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 638,
    y1: 121.43,
    x2: 638,
    y2: 186.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 641.5,
    y1: 121,
    x2: 634.5,
    y2: 121
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 641.5,
    y1: 187,
    x2: 634.5,
    y2: 187
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 620,
    y1: 123.42,
    x2: 620,
    y2: 187.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 623.5,
    y1: 123,
    x2: 616.5,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 623.5,
    y1: 188,
    x2: 616.5,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 603,
    y1: 132.42,
    x2: 603,
    y2: 196.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 606.5,
    y1: 132,
    x2: 599.5,
    y2: 132
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 606.5,
    y1: 197,
    x2: 599.5,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 585,
    y1: 158.4,
    x2: 585,
    y2: 218.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 588.5,
    y1: 158,
    x2: 581.5,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 588.5,
    y1: 219,
    x2: 581.5,
    y2: 219
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 568,
    y1: 159.4,
    x2: 568,
    y2: 219.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 571.5,
    y1: 159,
    x2: 564.5,
    y2: 159
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 571.5,
    y1: 220,
    x2: 564.5,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 550,
    y1: 119.71,
    x2: 550,
    y2: 227.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 553.5,
    y1: 119,
    x2: 546.5,
    y2: 119
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 553.5,
    y1: 228,
    x2: 546.5,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 532,
    y1: 103.74,
    x2: 532,
    y2: 216.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 535.5,
    y1: 103,
    x2: 528.5,
    y2: 103
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 535.5,
    y1: 217,
    x2: 528.5,
    y2: 217
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 515,
    y1: 100.78,
    x2: 515,
    y2: 219.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.5,
    y1: 100,
    x2: 511.5,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 518.5,
    y1: 220,
    x2: 511.5,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 497,
    y1: 96.81,
    x2: 497,
    y2: 219.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 500.5,
    y1: 96,
    x2: 493.5,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 500.5,
    y1: 220,
    x2: 493.5,
    y2: 220
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 480,
    y1: 108.8,
    x2: 480,
    y2: 230.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 483.5,
    y1: 108,
    x2: 476.5,
    y2: 108
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 483.5,
    y1: 231,
    x2: 476.5,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 462,
    y1: 112.8,
    x2: 462,
    y2: 234.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 465.5,
    y1: 112,
    x2: 458.5,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 465.5,
    y1: 235,
    x2: 458.5,
    y2: 235
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 444,
    y1: 124.79,
    x2: 444,
    y2: 244.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 447.5,
    y1: 124,
    x2: 440.5,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 447.5,
    y1: 245,
    x2: 440.5,
    y2: 245
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 427,
    y1: 124.79,
    x2: 427,
    y2: 244.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 430.5,
    y1: 124,
    x2: 423.5,
    y2: 124
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 430.5,
    y1: 245,
    x2: 423.5,
    y2: 245
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 409,
    y1: 117.8,
    x2: 409,
    y2: 239.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.5,
    y1: 117,
    x2: 405.5,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 412.5,
    y1: 240,
    x2: 405.5,
    y2: 240
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 391,
    y1: 112.82,
    x2: 391,
    y2: 237.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.5,
    y1: 112,
    x2: 387.5,
    y2: 112
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 394.5,
    y1: 238,
    x2: 387.5,
    y2: 238
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 374,
    y1: 172.44,
    x2: 374,
    y2: 238.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 377.5,
    y1: 172,
    x2: 370.5,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 377.5,
    y1: 239,
    x2: 370.5,
    y2: 239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 356,
    y1: 181.44,
    x2: 356,
    y2: 248.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 359.5,
    y1: 181,
    x2: 352.5,
    y2: 181
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 359.5,
    y1: 249,
    x2: 352.5,
    y2: 249
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 339,
    y1: 193.42,
    x2: 339,
    y2: 257.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.5,
    y1: 193,
    x2: 335.5,
    y2: 193
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 342.5,
    y1: 258,
    x2: 335.5,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 321,
    y1: 210.42,
    x2: 321,
    y2: 273.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 324.5,
    y1: 210,
    x2: 317.5,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 324.5,
    y1: 274,
    x2: 317.5,
    y2: 274
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 304,
    y1: 210.44,
    x2: 304,
    y2: 276.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.5,
    y1: 210,
    x2: 300.5,
    y2: 210
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 307.5,
    y1: 277,
    x2: 300.5,
    y2: 277
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 286,
    y1: 217.42,
    x2: 286,
    y2: 281.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 289.5,
    y1: 217,
    x2: 282.5,
    y2: 217
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 289.5,
    y1: 282,
    x2: 282.5,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 269,
    y1: 218.42,
    x2: 269,
    y2: 282.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 272.5,
    y1: 218,
    x2: 265.5,
    y2: 218
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 272.5,
    y1: 283,
    x2: 265.5,
    y2: 283
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 251,
    y1: 224.42,
    x2: 251,
    y2: 288.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 254.5,
    y1: 224,
    x2: 247.5,
    y2: 224
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 254.5,
    y1: 289,
    x2: 247.5,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 233,
    y1: 225.44,
    x2: 233,
    y2: 291.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 236.5,
    y1: 225,
    x2: 229.5,
    y2: 225
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 236.5,
    y1: 292,
    x2: 229.5,
    y2: 292
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216,
    y1: 233.44,
    x2: 216,
    y2: 299.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219.5,
    y1: 233,
    x2: 212.5,
    y2: 233
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219.5,
    y1: 300,
    x2: 212.5,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 198,
    y1: 239.44,
    x2: 198,
    y2: 305.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.5,
    y1: 239,
    x2: 194.5,
    y2: 239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 201.5,
    y1: 306,
    x2: 194.5,
    y2: 306
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 180,
    y1: 236.44,
    x2: 180,
    y2: 302.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 183.5,
    y1: 236,
    x2: 176.5,
    y2: 236
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 183.5,
    y1: 303,
    x2: 176.5,
    y2: 303
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 163,
    y1: 216.45,
    x2: 163,
    y2: 285.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.5,
    y1: 216,
    x2: 159.5,
    y2: 216
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.5,
    y1: 286,
    x2: 159.5,
    y2: 286
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 145,
    y1: 202.47,
    x2: 145,
    y2: 273.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 148.5,
    y1: 202,
    x2: 141.5,
    y2: 202
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 148.5,
    y1: 274,
    x2: 141.5,
    y2: 274
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 127,
    y1: 200.44,
    x2: 127,
    y2: 266.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130.5,
    y1: 200,
    x2: 123.5,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 130.5,
    y1: 267,
    x2: 123.5,
    y2: 267
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 110,
    y1: 197.44,
    x2: 110,
    y2: 264.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 113.5,
    y1: 197,
    x2: 106.5,
    y2: 197
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 113.5,
    y1: 265,
    x2: 106.5,
    y2: 265
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 93,
    y1: 199.45,
    x2: 93,
    y2: 267.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.5,
    y1: 199,
    x2: 89.5,
    y2: 199
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 96.5,
    y1: 268,
    x2: 89.5,
    y2: 268
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 75,
    y1: 207.45,
    x2: 75,
    y2: 275.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.5,
    y1: 207,
    x2: 71.5,
    y2: 207
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.5,
    y1: 276,
    x2: 71.5,
    y2: 276
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1184 188 1166 170 1148 168 1130.5 123.5 1113.5 130.5 1095.5 123.5 1078.5 124.5 1060.5 119.5 1042.5 116.5 1025.5 96.5 1007.5 96.5 990.5 91.5 972.5 82.5 954.5 106.5 937.5 100.5 919.5 82.5 901.5 70.5 884.5 60.5 867.5 54.5 849.5 64.5 831.5 82.5 814.5 93.5 795.5 97.5 778.5 93.5 761.5 84.5 743.5 112.5 726.5 122.5 708.5 145.5 690.5 157.5 673.5 161.5 655.5 148.5 637.5 154.5 620.5 154.5 602.5 165.5 585.5 187.5 566.5 189.5 549.5 172.5 532.5 159.5 515.5 160.5 496.5 158.5 479.5 169.5 462.5 173.5 444.5 184.5 426.5 184.5 409.5 178.5 391.5 174.5 373.5 206.5 355.5 215.5 338.5 226.5 321.5 242.5 303.5 242.5 285.5 249.5 268.5 250.5 250.5 256.5 233.5 257.5 215.5 265.5 198.5 270.5 180.5 268.5 162.5 250.5 144.5 237.5 127.5 233.5 109.5 225.5 92.5 226.5 74.5 223.5 64.5 213.5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.09,335H64.91A4.93,4.93,0,0,0,60,339.91v15.18A4.93,4.93,0,0,0,64.91,360h43.18a4.93,4.93,0,0,0,4.91-4.91V339.91A4.93,4.93,0,0,0,108.09,335ZM82.72,352.62H80.36v-7.17l-2.82,7.17h-2l-2.82-7.08v7.08H70.49V341.81h3.14l3,7.3,2.82-7.3h3.3Zm9.59,0-.78-2.2H87.36l-.78,2.2H84.05l4.07-10.81h2.79l4,10.81Zm7.74-4.51v4.51h-2.4v-4.51l-3.75-6.3h2.82l2.21,4,2.24-4h2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.77 348.23 88.15 348.23 89.48 344.49 90.77 348.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,335H279.94a5,5,0,0,0-4.94,4.94v15.12a5,5,0,0,0,4.94,4.94h43.12a5,5,0,0,0,4.94-4.94V339.94A5,5,0,0,0,323.06,335Zm-29.49,14.16a3.55,3.55,0,0,1-3.49,3.61h-.16a3.55,3.55,0,0,1-2.62-1,3.45,3.45,0,0,1-1-2.58v-.72l2.29-.39v1a1.37,1.37,0,0,0,.37,1,1.3,1.3,0,0,0,.94.36,1.15,1.15,0,0,0,.92-.39,1.46,1.46,0,0,0,.35-1v-7.36h2.4Zm10.73-.51a3.88,3.88,0,0,1-1.21,3.05,4.88,4.88,0,0,1-6.14,0,3.88,3.88,0,0,1-1.21-3.05v-6.91h2.4v6.71a2,2,0,0,0,.5,1.46,2.15,2.15,0,0,0,2.76,0,2,2,0,0,0,.49-1.46v-6.71h2.41Zm11.64,3.9H313.4l-4.45-7.1v7.1h-2.4V341.74h2.93l4,6.57v-6.57h2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.06,335H524.94a5,5,0,0,0-4.94,4.94v15.12a5,5,0,0,0,4.94,4.94h43.12a5,5,0,0,0,4.94-4.94V339.94A5,5,0,0,0,568.06,335Zm-27.49,14.16a3.55,3.55,0,0,1-3.49,3.61h-.16a3.55,3.55,0,0,1-2.62-1,3.45,3.45,0,0,1-1-2.58v-.72l2.29-.39v1a1.37,1.37,0,0,0,.37,1,1.3,1.3,0,0,0,.94.36,1.15,1.15,0,0,0,.92-.39,1.46,1.46,0,0,0,.35-1v-7.36h2.4Zm10.73-.51a3.88,3.88,0,0,1-1.21,3.05,4.88,4.88,0,0,1-6.14,0,3.88,3.88,0,0,1-1.21-3.05v-6.91h2.4v6.71a2,2,0,0,0,.5,1.46,2.15,2.15,0,0,0,2.76,0,2,2,0,0,0,.49-1.46v-6.71h2.41Zm9.32,3.9h-7.07V341.74H556v8.51h4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.06,335H765.94a5,5,0,0,0-4.94,4.94v15.12a5,5,0,0,0,4.94,4.94h43.12a5,5,0,0,0,4.94-4.94V339.94A5,5,0,0,0,809.06,335Zm-29.65,17.55-.78-2.2h-4.17l-.78,2.2h-2.53l4.07-10.81H778l4,10.81Zm12.05-3.9a3.88,3.88,0,0,1-1.21,3.05,4.88,4.88,0,0,1-6.14,0,3.88,3.88,0,0,1-1.21-3.05v-6.91h2.41v6.71a2,2,0,0,0,.49,1.46,2.15,2.15,0,0,0,2.76,0,2,2,0,0,0,.5-1.46v-6.71h2.4Zm5,1a3.14,3.14,0,0,0,2.32.91,2.77,2.77,0,0,0,1.86-.57,2.25,2.25,0,0,0,.8-1.2H798.2v-2h5.5v5.78h-2l-.15-1.1a3,3,0,0,1-1.18.94,4.11,4.11,0,0,1-1.86.38,5.33,5.33,0,0,1-3.89-1.56,5.46,5.46,0,0,1-1.58-4.06,5.39,5.39,0,0,1,1.64-4.06,5.58,5.58,0,0,1,4-1.58,5.17,5.17,0,0,1,3.33,1,4.85,4.85,0,0,1,1.66,2.35l-2.31.81a2.59,2.59,0,0,0-2.68-1.89,3.18,3.18,0,0,0-3.22,3.38,3.32,3.32,0,0,0,1,2.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.87 348.16 775.25 348.16 776.58 344.42 777.87 348.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.06,335h-43.12a5,5,0,0,0-4.94,4.94v15.12a5,5,0,0,0,4.94,4.94h43.12a5,5,0,0,0,4.94-4.94V339.94A5,5,0,0,0,1053.06,335Zm-27.34,16.75a4.08,4.08,0,0,1-2.91,1,4.43,4.43,0,0,1-3.16-1,3.79,3.79,0,0,1-1.25-2.4l2.21-.54a2,2,0,0,0,.63,1.34,2.25,2.25,0,0,0,1.61.52,1.84,1.84,0,0,0,1.11-.31,1,1,0,0,0,.41-.82.91.91,0,0,0-.31-.69,1.59,1.59,0,0,0-.85-.39l-1.48-.27a3.78,3.78,0,0,1-2.15-1.12,2.89,2.89,0,0,1-.79-2.05,3.15,3.15,0,0,1,1.15-2.49,4,4,0,0,1,2.72-1,5,5,0,0,1,1.72.27,3.28,3.28,0,0,1,1.19.71,3.87,3.87,0,0,1,.7.91,3.48,3.48,0,0,1,.34,1l-2.16.61a1.64,1.64,0,0,0-1.8-1.35,1.58,1.58,0,0,0-1.07.34,1,1,0,0,0-.41.82c0,.55.36.9,1.07,1l1.44.28a4,4,0,0,1,2.31,1.16,3,3,0,0,1,.82,2.08,3.17,3.17,0,0,1-1.09,2.39Zm9.59.8h-6.86V341.74h6.84V344h-4.43v2.06h4v2.12h-4v2.07h4.45Zm8.77-4.85a3.79,3.79,0,0,1-2.68,1h-1.66v3.89h-2.4V341.74h4.06a3.79,3.79,0,0,1,2.68,1,3.52,3.52,0,0,1,0,5l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.09,77H4.91A4.93,4.93,0,0,0,0,81.91V97.09A4.93,4.93,0,0,0,4.91,102H48.09A4.93,4.93,0,0,0,53,97.09V81.91A4.93,4.93,0,0,0,48.09,77ZM16.63,94.08a5.66,5.66,0,0,1-4.36,1.64,5.12,5.12,0,0,1-2.57-.57L10.28,93a4.2,4.2,0,0,0,1.94.44,3.84,3.84,0,0,0,2.3-.67,2.68,2.68,0,0,0,1.05-2.05,2.38,2.38,0,0,1-1,.78,3.52,3.52,0,0,1-1.41.29,3.81,3.81,0,0,1-2.71-1,3.51,3.51,0,0,1-1.1-2.67,3.63,3.63,0,0,1,1.2-2.8,4.45,4.45,0,0,1,3.12-1.1,4.17,4.17,0,0,1,3.23,1.38,5.67,5.67,0,0,1,1.25,3.93A6.49,6.49,0,0,1,16.63,94.08Zm10,.52a4.33,4.33,0,0,1-3.16,1.14,4.38,4.38,0,0,1-3-1,3.42,3.42,0,0,1-1.3-2.39l2.49-.51A1.72,1.72,0,0,0,22.21,93a1.74,1.74,0,0,0,1.27.48A1.68,1.68,0,0,0,24.66,93a1.7,1.7,0,0,0,0-2.38,1.85,1.85,0,0,0-1.22-.42,1.89,1.89,0,0,0-1.54.71l-.38-.13-.82-.26-.81-.25-.39-.14,1.24-5.73h6.41v2.24H22.56l-.44,2.08a2.73,2.73,0,0,1,1.87-.6,3.91,3.91,0,0,1,2.77,1,3.54,3.54,0,0,1,1,2.73A3.73,3.73,0,0,1,26.64,94.6Zm16.57.87H40.58v-8l-3.15,8H35.25l-3.14-7.89v7.89H29.55V83.41h3.51l3.32,8.15,3.14-8.15h3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729,0H614a5.05,5.05,0,0,0-5,5V20a5.05,5.05,0,0,0,5,5H729a5.05,5.05,0,0,0,5-5V5A5.05,5.05,0,0,0,729,0ZM629.34,16.89a3.87,3.87,0,0,1-2.83,1,4.36,4.36,0,0,1-3.08-1,3.75,3.75,0,0,1-1.22-2.34l2.15-.52a2,2,0,0,0,.62,1.3,2.15,2.15,0,0,0,1.56.51,1.74,1.74,0,0,0,1.08-.3,1,1,0,0,0,.4-.8.9.9,0,0,0-.29-.67,1.71,1.71,0,0,0-.83-.38l-1.44-.27a3.68,3.68,0,0,1-2.1-1.08,2.84,2.84,0,0,1-.76-2,3.07,3.07,0,0,1,1.11-2.42,3.92,3.92,0,0,1,2.65-1,5,5,0,0,1,1.67.25,3.39,3.39,0,0,1,1.17.69,3.92,3.92,0,0,1,.67.89,3.46,3.46,0,0,1,.33,1l-2.1.59a1.67,1.67,0,0,0-.49-.9A1.71,1.71,0,0,0,626.35,9a1.52,1.52,0,0,0-1,.34,1,1,0,0,0-.4.79c0,.54.34.88,1,1l1.41.26a3.87,3.87,0,0,1,2.24,1.14,2.93,2.93,0,0,1,.8,2A3.08,3.08,0,0,1,629.34,16.89Zm9.42.78L638,15.54h-4.06l-.76,2.13h-2.46l4-10.51h2.72l3.91,10.51Zm8.17,0h-2.41L640.66,7.16h2.58l2.54,7.4,2.5-7.4h2.5Zm11.81,0h-6.68V7.16h6.66V9.37h-4.31v2h3.91v2.06h-3.91v2h4.33Zm12.29,0h-6.67V7.16H671V9.37h-4.3v2h3.92v2.06H666.7v2H671Zm7.33,0h-2.42L672.09,7.16h2.58l2.53,7.4,2.51-7.4h2.49Zm11.81,0h-6.68V7.16h6.66V9.37h-4.32v2h3.92v2.06h-3.92v2h4.34Zm11.1,0H698.8l-4.33-6.91v6.91h-2.33V7.16H695l3.94,6.39V7.16h2.34ZM711.51,9.4h-3.25v8.27h-2.34V9.4h-3.24V7.16h8.83Zm7.8,7.49a4,4,0,0,1-2.83,1,4.31,4.31,0,0,1-3.08-1,3.61,3.61,0,0,1-1.22-2.34l2.15-.52a2,2,0,0,0,.61,1.3,2.19,2.19,0,0,0,1.57.51,1.81,1.81,0,0,0,1.08-.3,1,1,0,0,0,.4-.8.89.89,0,0,0-.3-.67,1.51,1.51,0,0,0-.83-.38l-1.44-.27a3.65,3.65,0,0,1-2.09-1.08,2.85,2.85,0,0,1-.77-2,3.07,3.07,0,0,1,1.11-2.42,4,4,0,0,1,2.66-1,5,5,0,0,1,1.67.25,3.25,3.25,0,0,1,1.16.69,4,4,0,0,1,.68.89,3.46,3.46,0,0,1,.33,1l-2.11.59a1.58,1.58,0,0,0-.49-.9A1.66,1.66,0,0,0,716.31,9a1.52,1.52,0,0,0-1,.34,1,1,0,0,0-.4.79c0,.54.34.88,1,1l1.41.26a3.87,3.87,0,0,1,2.25,1.14,2.92,2.92,0,0,1,.79,2,3.12,3.12,0,0,1-1.05,2.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.26 13.4 634.71 13.4 636 9.77 637.26 13.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.09,1.1H4.91A4.93,4.93,0,0,0,0,6V21.19A4.93,4.93,0,0,0,4.91,26.1H48.09A4.93,4.93,0,0,0,53,21.19V6A4.93,4.93,0,0,0,48.09,1.1ZM12.72,19.57H10.05V12.39H7.41V10.6a3.44,3.44,0,0,0,2-.61,2.24,2.24,0,0,0,1-1.46h2.3Zm7.09,0H17.14V12.39H14.5V10.6a3.45,3.45,0,0,0,2-.61,2.22,2.22,0,0,0,1-1.46h2.3Zm9.31-.87A4.29,4.29,0,0,1,26,19.84a4.38,4.38,0,0,1-3-1,3.42,3.42,0,0,1-1.3-2.39l2.48-.51A1.71,1.71,0,0,0,26,17.56a1.68,1.68,0,0,0,1.17-.43,1.68,1.68,0,0,0,0-2.37,1.8,1.8,0,0,0-1.22-.43,1.89,1.89,0,0,0-1.55.72L24,14.91l-.83-.26c-.29-.09-.56-.16-.8-.25l-.4-.14L23.2,8.53h6.41v2.24H25.05l-.44,2.08a2.71,2.71,0,0,1,1.87-.6,3.91,3.91,0,0,1,2.77,1,3.57,3.57,0,0,1,1,2.73A3.71,3.71,0,0,1,29.12,18.7Zm16.58.87H43.06v-8l-3.14,8H37.74l-3.15-7.89v7.89H32V7.51h3.51l3.31,8.15L42,7.51H45.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.21,88a1.47,1.47,0,0,1-.47,1.13,1.69,1.69,0,0,1-1.18.44,1.67,1.67,0,0,1-1.18-.44,1.58,1.58,0,0,1,0-2.25,1.67,1.67,0,0,1,1.18-.44,1.7,1.7,0,0,1,1.19.44A1.49,1.49,0,0,1,15.21,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.7,345.22a1.24,1.24,0,0,1-.43,1,1.62,1.62,0,0,1-1.11.38h-1.4v-2.76h1.4a1.63,1.63,0,0,1,1.12.37A1.3,1.3,0,0,1,1042.7,345.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.09,154.64H4.91A4.93,4.93,0,0,0,0,159.55v15.18a4.94,4.94,0,0,0,4.91,4.91H48.09A4.94,4.94,0,0,0,53,174.73V159.55A4.93,4.93,0,0,0,48.09,154.64Zm-29.6,9.57c-.25.22-.49.44-.71.66a13,13,0,0,0-1,1.18,11.7,11.7,0,0,0-2,4.11,14.26,14.26,0,0,0-.57,3H11.38a15.76,15.76,0,0,1,.37-2.3,11.8,11.8,0,0,1,.62-1.95c.23-.57.49-1.12.75-1.62a9.77,9.77,0,0,1,.79-1.27c.26-.35.5-.66.71-.92a5.14,5.14,0,0,1,.52-.56l.19-.19H9.92v-2.24h8.57Zm7.85,8a4.36,4.36,0,0,1-3.15,1.13,4.38,4.38,0,0,1-3-1,3.38,3.38,0,0,1-1.3-2.39l2.48-.52a1.71,1.71,0,0,0,.52,1.18,1.75,1.75,0,0,0,1.27.48,1.68,1.68,0,0,0,1.17-.43,1.52,1.52,0,0,0,.48-1.18,1.49,1.49,0,0,0-.51-1.2,1.77,1.77,0,0,0-1.21-.42,1.9,1.9,0,0,0-1.55.71l-.38-.14c-.26-.07-.53-.16-.82-.26s-.56-.16-.81-.25-.38-.13-.39-.13l1.24-5.74h6.42v2.24H22.27l-.45,2.09a2.76,2.76,0,0,1,1.88-.6,4,4,0,0,1,2.77,1,3.59,3.59,0,0,1,1,2.74A3.72,3.72,0,0,1,26.34,172.24Zm16.58.87H40.28v-8l-3.15,8H35l-3.15-7.89v7.89H29.26V161.05h3.5l3.32,8.14,3.15-8.14h3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.09,231.71H4.91A4.93,4.93,0,0,0,0,236.62V251.8a4.93,4.93,0,0,0,4.91,4.91H48.09A4.93,4.93,0,0,0,53,251.8V236.62A4.93,4.93,0,0,0,48.09,231.71Zm-30.55,17.6a4.33,4.33,0,0,1-3.16,1.14,4.38,4.38,0,0,1-3-1,3.42,3.42,0,0,1-1.3-2.39l2.49-.51a1.72,1.72,0,0,0,.51,1.17,1.74,1.74,0,0,0,1.27.48,1.68,1.68,0,0,0,1.18-.43,1.7,1.7,0,0,0,0-2.38,1.83,1.83,0,0,0-1.22-.42,1.89,1.89,0,0,0-1.54.71l-.38-.13-.82-.26-.81-.25-.39-.14,1.24-5.73H18v2.24H13.46L13,243.46a2.73,2.73,0,0,1,1.87-.6,4,4,0,0,1,2.78,1,3.57,3.57,0,0,1,1,2.73A3.73,3.73,0,0,1,17.54,249.31Zm9.47,0a4.3,4.3,0,0,1-3.15,1.14,4.38,4.38,0,0,1-3-1,3.42,3.42,0,0,1-1.3-2.39l2.48-.51a1.71,1.71,0,0,0,1.79,1.65,1.68,1.68,0,0,0,1.17-.43,1.5,1.5,0,0,0,.48-1.17,1.52,1.52,0,0,0-.5-1.21,1.85,1.85,0,0,0-1.22-.42,1.91,1.91,0,0,0-1.55.71l-.37-.13-.83-.26-.81-.25-.39-.14,1.24-5.73H27.5v2.24H22.94l-.44,2.08a2.71,2.71,0,0,1,1.87-.6,3.93,3.93,0,0,1,2.77,1,3.57,3.57,0,0,1,1,2.73A3.71,3.71,0,0,1,27,249.31Zm16.58.87H41v-8l-3.14,8H35.63l-3.15-7.89v7.89H29.93V238.12h3.5l3.32,8.15,3.15-8.15h3.69Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.fa367e524b35bae51633ff66f3204bdb.svg";
export { ForwardRef as ReactComponent };